// SM WORKS Handy-Menü und Suche (Thomas 02.11.2026), Styles in smw-header.css
document.addEventListener('click', function (event) {
  // Handy-Menü: Zeile klappt auf, immer nur eine offen
  var zeile = event.target.closest('button.smw-md__zeile');
  if (zeile) {
    var eintrag = zeile.closest('.smw-md__eintrag');
    var wirdOffen = !eintrag.classList.contains('is-offen');
    eintrag.closest('.smw-md').querySelectorAll('.smw-md__eintrag.is-offen').forEach(function (offen) {
      offen.classList.remove('is-offen');
      offen.querySelector('button.smw-md__zeile').setAttribute('aria-expanded', 'false');
    });
    if (wirdOffen) {
      eintrag.classList.add('is-offen');
      zeile.setAttribute('aria-expanded', 'true');
      setTimeout(function () { eintrag.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 320);
    }
    return;
  }

  // Suche: Chip trägt den Begriff ein und zeigt die Treffer direkt an
  var chip = event.target.closest('.smw-su__chip');
  if (chip) {
    var suche = chip.closest('predictive-search');
    var feld = suche && suche.querySelector('input[type="search"]');
    if (!feld) return;
    event.preventDefault();
    feld.value = chip.dataset.begriff;
    feld.dispatchEvent(new Event('input', { bubbles: true }));
    if (window.matchMedia('(hover: hover)').matches) feld.focus();   // am Handy nicht, sonst deckt die Tastatur die Treffer zu
  }
});
